var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4065 2.015C11.988 2.015 11.5665 2.1835 11.25 2.5L4.906 8.75L4.594 9.047C4.219 9.117 3.8605 9.302 3.578 9.6095C3.1615 10.0635 3.0805 10.6195 2.922 11.2185C2.763 11.8165 2.562 12.4815 2.078 13.2185L1.578 13.9995H2.5C4.4575 13.9995 5.7475 13.0645 6.4065 12.4055L6.4215 12.3905C6.723 12.082 6.8915 11.693 6.953 11.2965L7.203 11.0615L13.547 4.8115V4.7965C13.851 4.4916 14.0218 4.07858 14.0218 3.648C14.0218 3.21741 13.851 2.80439 13.547 2.4995C13.23 2.183 12.8245 2.0145 12.406 2.0145L12.4065 2.015ZM12.4065 3C12.563 3 12.7105 3.07 12.844 3.203C13.1105 3.47 13.1105 3.827 12.844 4.094L8.328 8.5625L7.422 7.656L11.953 3.203C12.0865 3.07 12.2495 3 12.4065 3ZM6.7025 8.36L7.609 9.265L6.859 10L5.952 9.0935L6.702 8.3595L6.7025 8.36ZM4.985 10.015C5.25691 10.0247 5.51668 10.13 5.7185 10.3125C6.1075 10.6685 6.1165 11.2895 5.7035 11.7025C5.2685 12.1375 4.4995 12.6955 3.375 12.906C3.615 12.381 3.7825 11.891 3.89 11.4845C4.057 10.857 4.179 10.4265 4.3125 10.281C4.486 10.091 4.7315 10.008 4.9845 10.015H4.985Z",
    fill: "#4F4FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.ec56971a45ba2e0024958a4f6e523a1b.svg";
export { ForwardRef as ReactComponent };